(function() {
  var initialized = false;
  var observer = null;

  function init() {
    var kachingBundle = document.querySelector('kaching-bundle');
    if (!kachingBundle) return;

    if (initialized) return;
    initialized = true;

    if (!kachingBundle.parentElement.classList.contains('kaching-bundle-inner')) {
      var wrapper = document.createElement('div');
      wrapper.className = 'kaching-bundle-wrapper';

      var inner = document.createElement('div');
      inner.className = 'kaching-bundle-inner';

      kachingBundle.parentNode.insertBefore(wrapper, kachingBundle);
      wrapper.appendChild(inner);
      inner.appendChild(kachingBundle);
    }

    var bundleWrapper = document.querySelector('.kaching-bundle-wrapper');
    var bundleMainWrapper = document.querySelector('#shopify-block-AOHYwL3p0MzlFQjlVM__kaching_bundles_app_block_mdg4wF');

    function toggleKachingBundle() {
      var subscribeButton = document.querySelector('#subify-widget-subscription-text');
      var oneTimeButton = document.querySelector('#subify-widget-one-time-purchase-text');

      /* Kaching-only product (no Subify widget) — just reveal Kaching and stop. */
      if (!subscribeButton || !oneTimeButton) {
        if (bundleWrapper) bundleWrapper.classList.remove('is-hidden');
        if (bundleMainWrapper) {
          bundleMainWrapper.classList.remove('is-hidden');
          bundleMainWrapper.classList.add('is-ready');
        }
        return;
      }

      var subscribeOption = subscribeButton.closest('.subify-minimal-option');
      var oneTimeOption = oneTimeButton.closest('.subify-minimal-option');

      if (!subscribeOption || !oneTimeOption) return;

      if (subscribeOption.classList.contains('active')) {
        if (bundleWrapper) bundleWrapper.classList.add('is-hidden');
        if (bundleMainWrapper) bundleMainWrapper.classList.add('is-hidden');

        var firstBundleInput = document.querySelector('.kaching-bundles__bar input');
        if (firstBundleInput) {
          firstBundleInput.checked = true;
          firstBundleInput.dispatchEvent(new Event('change', { bubbles: true }));
          firstBundleInput.click();
        }
      }

      if (oneTimeOption.classList.contains('active')) {
        if (bundleWrapper) bundleWrapper.classList.remove('is-hidden');
        if (bundleMainWrapper) {
          bundleMainWrapper.classList.remove('is-hidden');
          bundleMainWrapper.classList.add('is-ready');
        }
      }
    }

    toggleKachingBundle();

    /* Re-check once Subify has had a chance to hydrate, in case the first
       pass ran before its widget was in the DOM. */
    setTimeout(toggleKachingBundle, 500);
    setTimeout(toggleKachingBundle, 1500);

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.subify-minimal-option')) return;
      setTimeout(toggleKachingBundle, 120);
    });
  }

  function checkReady() {
    if (document.querySelector('kaching-bundle')) {
      init();
      if (initialized) {
        if (observer) observer.disconnect();
        return true;
      }
    }
    return false;
  }

  if (checkReady()) return;

  observer = new MutationObserver(checkReady);
  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function() {
    observer.disconnect();
  }, 15000);
})();


/* Subi/Kaching toggle for quick-add modals */
(function() {
  function initModalToggle(modal) {
    var kachingBundle = modal.querySelector('kaching-bundle');
    var kachingBlock = kachingBundle ? kachingBundle.closest('.shopify-block') : null;

    if (!kachingBundle || !kachingBlock) return;

    function toggleKaching() {
      var subscribeBtn = modal.querySelector('#subify-widget-subscription-text');
      var oneTimeBtn = modal.querySelector('#subify-widget-one-time-purchase-text');

      if (!subscribeBtn || !oneTimeBtn) {
        kachingBlock.classList.remove('is-hidden');
        kachingBlock.classList.add('is-ready');
        return;
      }

      var subscribeOption = subscribeBtn.closest('.subify-minimal-option');
      var oneTimeOption = oneTimeBtn.closest('.subify-minimal-option');

      if (!subscribeOption || !oneTimeOption) return;

      if (subscribeOption.classList.contains('active')) {
        kachingBlock.classList.add('is-hidden');

        var firstInput = kachingBundle.querySelector('.kaching-bundles__bar input');
        if (firstInput) {
          firstInput.checked = true;
          firstInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      if (oneTimeOption.classList.contains('active')) {
        kachingBlock.classList.remove('is-hidden');
      }
    }

    modal.addEventListener('click', function(e) {
      if (e.target.closest('.subify-minimal-option')) {
        setTimeout(toggleKaching, 150);
      }
    });

    toggleKaching();

    /* Reveal after initial toggle */
    kachingBlock.classList.add('is-ready');
  }

  /* Watch for quick-add modals opening */
  function observeQuickAddModals() {
    document.querySelectorAll('quick-add-modal').forEach(function(modal) {
      if (modal.dataset.kachingToggleObserved) return;
      modal.dataset.kachingToggleObserved = 'true';

      var attrObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
            /* Wait for modal content + Subi + Kaching to load */
            var attempts = 0;
            var kachingHidden = false;
            var waitInterval = setInterval(function() {
              attempts++;
              var hasSubi = modal.querySelector('.subify-minimal-option');
              var hasKaching = modal.querySelector('kaching-bundle');

              if (hasKaching && !kachingHidden) {
                var block = hasKaching.closest('.shopify-block');
                if (block) {
                  block.classList.remove('is-ready');
                  block.classList.remove('is-hidden');
                }
                kachingHidden = true;
              }

              if (hasSubi && hasKaching) {
                clearInterval(waitInterval);
                initModalToggle(modal);
              } else if (attempts >= 40) {
                clearInterval(waitInterval);
                if (kachingHidden && hasKaching) {
                  var block = hasKaching.closest('.shopify-block');
                  if (block) block.classList.add('is-ready');
                }
              }
            }, 250);
          }
        });
      });

      attrObserver.observe(modal, { attributes: true });
    });
  }

  observeQuickAddModals();

  /* Re-observe when new modals are added (cart cross-sells) */
  var bodyObserver = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        observeQuickAddModals();
        break;
      }
    }
  });

  bodyObserver.observe(document.body, { childList: true });
})();

(function () {
  function removeSubifyFromHighlightTags() {
    document.querySelectorAll('.custom-highlight-tags .subify-root').forEach(function (el) {
      el.remove();
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', function () {
    removeSubifyFromHighlightTags();
  });

  // Watch for Subify injecting it dynamically
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // Check if the added node itself is the rogue subify-root
        if (node.classList && node.classList.contains('subify-root')) {
          var parent = node.parentElement;
          if (parent && parent.classList.contains('custom-highlight-tags')) {
            node.remove();
          }
        }

        // Also check if it was added inside .custom-highlight-tags
        if (node.querySelector) {
          node.querySelectorAll('.custom-highlight-tags .subify-root').forEach(function (el) {
            el.remove();
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function() {
  const MOBILE_MAX = 749;

  function moveMediaToBeforeHighlights() {
    // Only on mobile — remove this block if you want it on desktop too
    if (window.innerWidth > MOBILE_MAX) return;

    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const highlightTags = document.querySelector('.custom-highlight-tags');

    if (!mediaWrapper || !highlightTags) return;
    if (mediaWrapper.dataset.movedBeforeHighlights === 'true') return;

    highlightTags.parentNode.insertBefore(mediaWrapper, highlightTags);
    mediaWrapper.dataset.movedBeforeHighlights = 'true';
  }

  if (document.readyState !== 'loading') {
    moveMediaToBeforeHighlights();
  } else {
    document.addEventListener('DOMContentLoaded', moveMediaToBeforeHighlights);
  }

  // Re-run on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', moveMediaToBeforeHighlights);
})();

(function() {
  const MOBILE_MAX = 749;

  function moveRecommendedProductBeforeBanner() {
    if (window.innerWidth > MOBILE_MAX) return;

    const recommendedProduct = document.querySelector('.custom-recommended-product');
    const banner = document.querySelector('#shopify-section-template--29855643959637__custom_image_text_banner_dgH36Y');

    if (!recommendedProduct || !banner) return;
    if (recommendedProduct.dataset.movedBeforeBanner === 'true') return;

    banner.parentNode.insertBefore(recommendedProduct, banner);
    recommendedProduct.dataset.movedBeforeBanner = 'true';
  }

  if (document.readyState !== 'loading') {
    moveRecommendedProductBeforeBanner();
  } else {
    document.addEventListener('DOMContentLoaded', moveRecommendedProductBeforeBanner);
  }

  document.addEventListener('shopify:section:load', moveRecommendedProductBeforeBanner);
})();

(function() {
  function bindRatingScroll() {
    const trigger = document.querySelector('.rating-wrapper');
    const target = document.getElementById('shopify-section-template--29855643959637__17780442328e692063');
    if (!trigger || !target) return;
    if (trigger.dataset.scrollBound === 'true') return;
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    trigger.dataset.scrollBound = 'true';
  }
  if (document.readyState !== 'loading') {
    bindRatingScroll();
  } else {
    document.addEventListener('DOMContentLoaded', bindRatingScroll);
  }
  document.addEventListener('shopify:section:load', bindRatingScroll);
})();

/* ---- Judge.me aria-selected patch — keep at top of file ---- */
(function () {
  function start() {
    try {
      var SELECTOR = '.jm-media-grid__item';

      function fix(el) {
        if (!el.matches || !el.matches(SELECTOR)) return;
        if (!el.hasAttribute('aria-selected')) return;
        var on = el.getAttribute('aria-selected') === 'true';
        el.removeAttribute('aria-selected');
        if (on) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      }

      function scan(root) {
        if (!root || root.nodeType !== 1) return;
        fix(root);
        root.querySelectorAll(SELECTOR).forEach(fix);
      }

      scan(document.body);

      new MutationObserver(function (records) {
        records.forEach(function (r) {
          if (r.type === 'attributes') fix(r.target);
          else r.addedNodes.forEach(scan);
        });
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-selected']
      });
    } catch (e) {
      console.warn('jm aria patch failed:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();